import vertexShader from "../../shaders/vertex.vert";
import fragmentShader from "../../shaders/car.frag";
import Utils from "../utils/helpers";
import MAD from "../mad-engine";

export default class Player extends MAD.Entity{
    constructor(){
        super();
        //THREE
        {
            const geometry = new THREE.BoxGeometry();
            const uniforms = {
                u_curve: { type: "float", value: 0 },
                u_progress: { type: "float", value: 0 },
                u_color: { type: "color", value: new THREE.Color(`white`) }
            };
            this.material =  new THREE.ShaderMaterial( {
                vertexShader,
                fragmentShader,
                uniforms
            } );
            const cube = new THREE.Mesh( geometry, this.material );
            cube.scale.set(0.5, 0.3, 1);
            cube.position.set(0,-0.35 + 0.3,0);
            this.root.add( cube );
            this.root.position.z = -5;
        }
        //MOVEMENT
        {
            this.ix = 0;
            this.targetX = 0;
        }
        //PHYSICS
        {
            this.hitbox = new MAD.Hitbox({root: this.root, offset: new THREE.Vector3(0,0,0), size: new THREE.Vector3(0.5, 0.2, 1)});
        }
    }

    update(){
        const { camera, inputs, clock } = MAD.App.instance;
        const { noise } = MAD.STORE.data;

        const ix = inputs.getAxis("KeyA","KeyD");
        const damp =  ix != 0 ? 0.2 : 0.05;
        this.ix += (ix - this.ix) * damp;
        this.root.position.x += this.ix * 7 * clock.delta;
        this.root.position.x = Utils.clamp(this.root.position.x, -3, 3);

        const diff = (this.root.position.x - this.targetX);
        this.targetX += diff * 0.15;

        this.root.position.y = noise.read(this.root.position.z);
        this.root.lookAt(this.targetX, noise.read(this.root.position.z - 1), this.root.position.z - 1);
        this.root.rotateZ(Math.PI * -diff * .5);
        
        camera.position.x = this.root.position.x;
        camera.position.y = noise.read(this.root.position.z) + 1;
        camera.position.z = this.root.position.z + 3;

        this.material.uniforms.u_curve.value = noise.getCurve();
        this.material.uniforms.u_progress.value = noise.getProgress();
        this.material.uniforms.needsUpdate = true;

    }
}